import * as React from "react";
import { useContext } from "react";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import FieldTypeMapping from "views/logic/fieldtypes/FieldTypeMapping";
import FieldType from "views/logic/fieldtypes/FieldType";
import { defaultCompare } from "logic/DefaultCompare";
import { isPermitted } from "util/PermissionsMixin";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import WatchlistDomain from "watchlist/domainActions/WatchlistDomain";
import WatchlistStatusContext from "watchlist/contexts/WatchlistStatusContext";
import defaultWatchlists from "security-content/mappings/watchlists";
import useLicenseCheck from "license/useLicenseCheck";
import useCurrentUser from "hooks/useCurrentUser";
import WatchlistIndicator from "./WatchlistIndicator";
const getWatchlistByType = (watchlists, type) => {
  const watchlist = Object.values(watchlists).find(({ fieldType }) => fieldType === type);
  if (!watchlist) {
    throw Error(`Could not find watchlist with field type ${type}`);
  }
  return watchlist.title;
};
const removeFieldFromWatchlist = (fieldName, fieldValue, watchlistTitle, watchlistFieldType) => {
  if (window.confirm(`Are you sure you want to remove the ${fieldName}: ${fieldValue} from the ${watchlistTitle}?`)) {
    WatchlistDomain.delete(watchlistFieldType, fieldValue);
  }
};
const getEnrichedFields = (watchlists, message, queryFields, fieldsWatchlistStatus) => {
  const fields = Object.entries(fieldsWatchlistStatus).reduce(
    (enrichedFields, [watchlistFieldType, watchlistFields]) => {
      const watchlistTitle = getWatchlistByType(watchlists, watchlistFieldType);
      const enrichedWatchlistFields = watchlistFields.map((fieldName) => {
        const fieldValue = message.fields[fieldName];
        const { type: fieldType } = queryFields.find(
          (t) => t.name === fieldName,
          void 0,
          FieldTypeMapping.create(fieldName, FieldType.Unknown)
        );
        return { fieldType, fieldName, fieldValue, watchlistTitle, watchlistFieldType };
      });
      return [...enrichedFields, ...enrichedWatchlistFields];
    },
    []
  );
  return fields.sort(({ fieldName: fieldName1 }, { fieldName: fieldName2 }) => defaultCompare(fieldName1, fieldName2));
};
const WatchlistAugmentation = ({ message, watchlists = defaultWatchlists }) => {
  const { status: watchlistStatus, isLoading } = useContext(WatchlistStatusContext) || {};
  const {
    security: { isValid: isValidSecurityLicense }
  } = useLicenseCheck();
  const fieldTypes = useContext(FieldTypesContext);
  const currentUser = useCurrentUser();
  const interactive = useContext(InteractiveContext);
  const allowRemoval = interactive && isPermitted(currentUser == null ? void 0 : currentUser.permissions, "watchlist:edit");
  if (!isValidSecurityLicense || isLoading || !watchlistStatus || Object.values(watchlistStatus).length === 0) {
    return null;
  }
  const queryFields = fieldTypes.currentQuery;
  const enrichedFields = getEnrichedFields(watchlists, message, queryFields, watchlistStatus);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Found on watchlist"), enrichedFields.map(({ fieldName, fieldValue, fieldType, watchlistTitle, watchlistFieldType }) => /* @__PURE__ */ React.createElement(
    WatchlistIndicator,
    {
      key: `${watchlistTitle}-${fieldName}`,
      title: watchlistTitle,
      fieldName,
      fieldValue,
      message,
      realFieldType: fieldType,
      allowRemoval,
      onDelete: () => removeFieldFromWatchlist(fieldName, fieldValue, watchlistTitle, watchlistFieldType)
    }
  )));
};
export default WatchlistAugmentation;
